var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useLayoutEffect, useRef } from 'react';
import { ESCAPE_KEY } from '#constants';
import { useGlobalKeyboardShortcut } from '#hooks';
import { safeHidePopover, safeShowPopover } from '#services';
import { Box } from '../Box';
import { IconButton } from '../buttons';
import { XCloseIcon } from '../icons';
import { Typography } from '../Typography';
import { DRAWER_WIDTH, DRAWER_WIDTH_CSS_VAR, DRAWER_WIDTH_RESET, } from './Drawer.constants';
import { DrawerTestIdFactory } from './interactions';
import styles from './Drawer.module.css';
export const Drawer = ({ children, closeButtonAriaLabel, closeDrawer, 'data-testid': testId, isInert = false, shouldHaveCloseButton = true, title, }) => {
    _react_refresh_temp_2();
    const dialogRef = useRef(null);
    const titleId = useId();
    useLayoutEffect(() => {
        const { style } = document.documentElement;
        const dialog = dialogRef.current;
        const opener = document.activeElement;
        style.setProperty(DRAWER_WIDTH_CSS_VAR, DRAWER_WIDTH);
        return () => {
            style.setProperty(DRAWER_WIDTH_CSS_VAR, DRAWER_WIDTH_RESET);
            const { activeElement } = document;
            const isFocusInDrawerOrLost = activeElement === document.body ||
                Boolean(dialog?.contains(activeElement));
            // A manual popover does not restore focus when hidden.
            if (isFocusInDrawerOrLost &&
                opener instanceof HTMLElement &&
                opener !== document.body &&
                opener.isConnected) {
                opener.focus();
            }
        };
    }, []);
    // The top layer paints over any overlay, so an inert drawer opens as a plain dialog under it
    useLayoutEffect(() => {
        const dialog = dialogRef.current;
        if (isInert) {
            dialog?.show();
        }
        else {
            safeShowPopover(dialog);
        }
        return () => {
            if (isInert) {
                dialog?.close();
            }
            else {
                safeHidePopover(dialog);
            }
        };
    }, [isInert]);
    // Escape closes the drawer from anywhere so it never hides focus behind it (WCAG 2.4.11)
    useGlobalKeyboardShortcut([
        {
            key: ESCAPE_KEY,
            onMatch: (event) => {
                // Inner popups prevent default; a modal over the drawer owns Escape
                if (event.defaultPrevented ||
                    document.querySelector('dialog:modal')) {
                    return;
                }
                event.preventDefault();
                closeDrawer();
            },
            preventDefault: false,
        },
    ], { enabled: !isInert });
    return (_jsx("dialog", { "aria-labelledby": titleId, className: styles.Container, inert: isInert, popover: "manual", ref: dialogRef, ...(testId && {
            'data-testid': DrawerTestIdFactory.getDrawerTestId(testId),
        }), children: _jsxs(Box, { align: "start", gap: "m", isFullHeight: true, isFullWidth: true, kind: "level2", orientation: "vertical", padding: "m", radius: "s", children: [_jsxs(Box, { align: "center", isFullWidth: true, children: [_jsx(Box, { isFullWidth: true, children: _jsx(Typography, { as: "h2", color: "accent", fontWeight: "bold", id: titleId, kind: "h5", children: title }) }), shouldHaveCloseButton && closeButtonAriaLabel && (_jsx(IconButton, { "aria-label": closeButtonAriaLabel, "data-testid": DrawerTestIdFactory.getDrawerCloseButtonBase(), Icon: XCloseIcon, kind: "ghost", onClick: closeDrawer, size: "medium" }))] }), children] }) }));
};
_react_refresh_temp_1 = Drawer;
$RefreshReg$(_react_refresh_temp_1, "Drawer");
_react_refresh_temp_2(Drawer, "406EctXArGJAb/jWZSrLx6mSG50=", false, () => [
    // Escape closes the drawer from anywhere so it never hides focus behind it (WCAG 2.4.11)
    useGlobalKeyboardShortcut]);
